import Groq from "groq-sdk";

const groq = new Groq({
  apiKey: import.meta.env.VITE_GROQ_API_KEY,
  dangerouslyAllowBrowser: true 
});

export const forgeAssistant = async (prompt, options = {}) => {
  try {
    const completion = await groq.chat.completions.create({
      messages: [
        {
          role: "system",
          content: `You are AetherForge-Workspace AI Assistant. 
          You are helpful, concise, and highly technical. 
          Help users with coding, system design, debugging, and product building, 
          project & task summaries and suggestions, intelligent metrics/analytics.
          You are a creative project ideation expert. 
          Always generate fresh, unique, and diverse ideas. 
          Never repeat previous project suggestions. 
          Always respond with valid JSON only`
        },
        {
          role: "user",
          content: prompt
        }
      ],
      model: options.model || "llama-3.3-70b-versatile", // Very fast & powerful
      temperature: options.temperature || 0.85,
      max_tokens: options.max_tokens || 1200,
      response_format: { type: "json_object" }
    });

    return completion.choices[0]?.message?.content || "No response";
  } catch (error) {
    console.error("Groq API Error:", error);
    throw new Error(error?.message || "Failed to get response from AI");
  }
};

// Optional: Streaming version (great for chat UI)
export const forgeAssistantStream = async (prompt, onChunk) => {
  const stream = await groq.chat.completions.create({
    messages: [{ role: "user", content: prompt }],
    model: "llama-3.3-70b-versatile",
    stream: true,
  });

  for await (const chunk of stream) {
    const content = chunk.choices[0]?.delta?.content || "";
    if (content) onChunk(content);
  }
};
